const {
  blockEditor: { useBlockProps, InnerBlocks, useSetting },
  data: { withSelect, useSelect },
} = wp;

/**
 * Every block starts by registering a new block type definition.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-registration/
 */

const Edit = (props) => {
  const { name, context, clientId } = props;
  const activeTab = context['b3rg/activeTab'];
  const enableMobileImageTab = context['b3rg/enableMobileImageTab'];
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const blockProps = useBlockProps();
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const innerBlockObj = useSelect(
    (select) => select('core/block-editor').getBlock(clientId).innerBlocks,
  );

  const ALLOWED_BLOCKS = useSetting(`custom.blocks.${name}.allowedBlocks`) ?? [
    'core/image',
  ];

  return (
    <div {...blockProps}>
      {activeTab === 'mobile' && enableMobileImageTab && (
        <InnerBlocks
          templateLock={false}
          // Limits the number of blocks to be used as top-level inner blocks to 1
          renderAppender={() =>
            innerBlockObj.length < 1 ? (
              <InnerBlocks.ButtonBlockAppender />
            ) : (
              false
            )
          }
          allowedBlocks={ALLOWED_BLOCKS}
        />
      )}
    </div>
  );
};

export default withSelect((select, { clientId }) => {
  const { getBlocks } = select('core/block-editor');
  const blocks = getBlocks(clientId);
  return { blocks };
})(Edit);
